import { useState } from "react";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
   
    {
      question: 'Do you assist with visa processing?',
      answer: 'Yes, we provide complete visa processing support, including document checks, consultation, and submission guidance to ensure a smooth process.'
    },
    {
      question: 'Can I buy airline tickets through your agency?',
      answer: 'Absolutely! We offer airline ticketing for both domestic and international flights, helping you find the best routes and prices.'
    },
    
    {
      question: 'What documents do I need for international travel?',
      answer: 'Requirements vary by destination, but you generally need a valid passport, visa (if required), and any necessary travel permits. Our team assists with all document-related inquiries.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-8 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 animate-fade-in">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            Quick answers to common travel questions
          </p>
        </div>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-2 cursor-pointer animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => toggleFAQ(index)}
            >
              <h3 className=" font-semibold text-gray-900 dark:text-white  flex justify-between">
                {faq.question}
                <span className="text-primary-600">
                  {openIndex === index ? "-" : "+"}
                </span>
              </h3>

              {openIndex === index && (
                <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
